import React, { useState } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import ShortyContentInfoDialog from "./ShortyContentInfoDialog";
import { stripHtml } from "core/utils/string";

export default function ShortyContentInfo({
  content,
  titleVariant = "h6",
  descriptionVariant = "body2",
  sx = {},
}) {
  const [infoDialogOpen, setInfoDialogOpen] = useState(false);

  if (!content) return null;

  const handleClick = () => {
    setInfoDialogOpen(true);
  };

  return (
    <>
      <Box
        sx={{
          cursor: "pointer",
          ...sx,
        }}
        onClick={handleClick}
      >
        {/* Заголовок */}
        <Typography
          sx={{
            color: "white",
            textShadow: "0 2px 4px rgba(0,0,0,0.8), 0 0 8px rgba(0,0,0,0.6)",
            fontWeight: "bold",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
          variant={titleVariant}
        >
          {stripHtml(content.title)}
        </Typography>

        {/* Описание */}
        {content.description && (
          <Typography
            sx={{
              color: "white",
              textShadow: "0 2px 4px rgba(0,0,0,0.8), 0 0 8px rgba(0,0,0,0.6)",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              mt: 0.5,
            }}
            variant={descriptionVariant}
          >
            {stripHtml(content.description)}
          </Typography>
        )}
      </Box>

      {/* Диалог с информацией о контенте */}
      <ShortyContentInfoDialog
        content={content}
        open={infoDialogOpen}
        onClose={() => setInfoDialogOpen(false)}
      />
    </>
  );
}

ShortyContentInfo.propTypes = {
  content: PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
    sport: PropTypes.shape({
      title: PropTypes.string,
      name: PropTypes.string,
    }),
    league: PropTypes.shape({
      title: PropTypes.string,
      name: PropTypes.string,
    }),
    teams: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
        name: PropTypes.string,
      })
    ),
    date: PropTypes.string,
  }),
  titleVariant: PropTypes.string,
  descriptionVariant: PropTypes.string,
  sx: PropTypes.object,
};
